import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-business-days';
import { loadSchedule } from 'actionCreators';
import InstallSuggestionsList from 'installSuggestionsList';
import Loading from 'components/Loading';
import ScheduleType from 'types/schedule';
import { AppointmentType } from 'types/appointment';
import PhaseType from 'types/phase';
import {
  groupSuggestionsByPage, sortSuggestions,
} from '../../../../../utils/schedulingUtils';
import { SCHEDULE_DATE, DISPLAY_DATE, DELIVERY_BUFFERS } from 'config/constants';
import S from './suggestions.scss';

class InstallSuggestions extends Component {
  constructor(props) {
    super(props);
    const { date, phase: {
      zip_code, surface_type: { id: surfaceId }, workroom: { id },
      phase_specific: { is_cali_bamboo_hardwood: isCaliBamboo },
    } } = this.props;
    this.state = {
      filters: {
        assignee_type: ['Crew'],
        crew: { zip_code },
        surface_type: [surfaceId],
        workroom: [id],
      },
      surfaceId,
      isCaliBamboo,
      queryStart: date,
    };
    this.loadSuggestions = this.loadSuggestions.bind(this);
    this.handleQueryStartChange = this.handleQueryStartChange.bind(this);
  }

  componentDidMount = () => this.loadSuggestions();

  loadSuggestions = () => {
    const { queryStart, filters } = this.state;
    const { phase, relatedPhases } = this.props;
    const startDate = moment(queryStart, SCHEDULE_DATE).toDate() || new Date();
    this.props.loadSchedule(startDate, filters, false, {}, { phase, relatedPhases });
  }

  handleQueryStartChange = date => this.setState({ queryStart: date });

  filterInstallsByDeliveryDate = (suggestions, deliveryStartDate) => {
    const { surfaceId, isCaliBamboo } = this.state;
    const viableSuggestions = suggestions;
    let buffer = 0;
    if (surfaceId === 1) {
      buffer = isCaliBamboo ? DELIVERY_BUFFERS[surfaceId][1] : DELIVERY_BUFFERS[surfaceId][0];
    } else buffer = DELIVERY_BUFFERS[surfaceId][0];
    if (deliveryStartDate) {
      const optimalMoment = moment(deliveryStartDate, DISPLAY_DATE).add(buffer, 'days');
      return viableSuggestions.filter((s) => {
        const openingMoment = moment(s.opening, DISPLAY_DATE);
        return openingMoment.isSameOrAfter(optimalMoment, 'day');
      });
    }
    return viableSuggestions;
  }

  paginateSuggestions = (suggestions, type = 'install') =>
    groupSuggestionsByPage(sortSuggestions(suggestions, type));

  renderNoDelivery = () => {
    const { deliveryArgs: { surfaceType, deliveryMethod, spigDelivery } } = this.props;
    const noDeliveryArr = [];
    if (surfaceType === 'Carpet') noDeliveryArr.push('surface type is carpet');
    if (deliveryMethod === 'None') noDeliveryArr.push('store has no delivery method');
    if (!spigDelivery) noDeliveryArr.push('delivery not purchased');
    return (
      <div className={S.suggestionCard__container} style={{ color: 'red' }}>
        <section className={S.suggestionCard}>
          Delivery not needed due to: {noDeliveryArr.join(', ')}
        </section>
      </div>
    );
  };

  render = () => {
    const { onSelect, zone, suggestionKey, schedulingReason, handleSchedulingReasonChange,
            errors, handleSubmit, handleAltSub, position, overrideToCal, needDelivery,
            suggestionDisableReason, deliveryStartDate, selectedDeliverySuggestion = null,
            deliveryArgs: { surfaceType },
            schedule: { loading = true, deliverySuggestions = [],
                        deliveryCount = 0, suggestions = [] } } = this.props;
    const { queryStart } = this.state;
    const installSuggestions = this.filterInstallsByDeliveryDate(suggestions, deliveryStartDate);
    return (loading ? (<Loading className={S.spinner} />) : (<Fragment>
      {needDelivery ? (<Fragment>
        <InstallSuggestionsList
          isDeliveryList
          position={position}
          suggestions={deliverySuggestions.length ?
            this.paginateSuggestions(deliverySuggestions, 'delivery') : [[]]}
          totalCount={deliveryCount}
          zone={zone}
          suggestionKey={suggestionKey}
          selectedDeliverySuggestion={selectedDeliverySuggestion}
          schedulingReason={schedulingReason}
          queryStart={queryStart}
          suggestionDisableReason={suggestionDisableReason}
          handleSelect={v => onSelect(v, 'delivery')}
          handleSubmit={handleSubmit}
          handleAltSub={handleAltSub}
          handleSchedulingReasonChange={handleSchedulingReasonChange}
          handleQueryStartChange={this.handleQueryStartChange}
          rerunLoadSuggestions={this.loadSuggestions}
          overrideToCal={overrideToCal}
          needDelivery={needDelivery}
          surfaceType={surfaceType}
          errors={errors}
        />
        <br />
      </Fragment>) : (<div>{this.renderNoDelivery()}</div>)}
      {(!needDelivery || selectedDeliverySuggestion) && <InstallSuggestionsList
        position={position}
        suggestions={installSuggestions.length ?
          this.paginateSuggestions(installSuggestions) : [[]]}
        totalCount={installSuggestions.length}
        zone={zone}
        suggestionKey={suggestionKey}
        selectedDeliverySuggestion={selectedDeliverySuggestion}
        schedulingReason={schedulingReason}
        queryStart={queryStart}
        suggestionDisableReason={suggestionDisableReason}
        handleSelect={onSelect}
        handleSubmit={handleSubmit}
        handleAltSub={handleAltSub}
        handleSchedulingReasonChange={handleSchedulingReasonChange}
        handleQueryStartChange={this.handleQueryStartChange}
        rerunLoadSuggestions={this.loadSuggestions}
        overrideToCal={overrideToCal}
        needDelivery={needDelivery}
        surfaceType={surfaceType}
        errors={errors}
      />}
    </Fragment>));
  }
}

InstallSuggestions.propTypes = {
  zone: PropTypes.string,
  loadSchedule: PropTypes.func.isRequired,
  schedule: ScheduleType.isRequired,
  position: PropTypes.string,
  date: PropTypes.string,
  suggestionDisableReason: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleAltSub: PropTypes.func.isRequired,
  handleSchedulingReasonChange: PropTypes.func.isRequired,
  overrideToCal: PropTypes.func.isRequired,
  pendingAppointment: AppointmentType,
  phase: PhaseType,
  relatedPhases: PropTypes.array,
  suggestionKey: PropTypes.string,
  selectedDeliverySuggestion: PropTypes.string,
  schedulingReason: PropTypes.string,
  needDelivery: PropTypes.bool,
  deliveryStartDate: PropTypes.string,
  deliveryArgs: PropTypes.object,
  errors: PropTypes.object,
};

InstallSuggestions.defaultProps = { date: new Date(), filters: {}, relatedPhases: [] };

export default connect(state => ({ schedule: state.schedule }),
  { loadSchedule })(InstallSuggestions);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/schedule/components/installSuggestions.jsx